module.exports = __webpack_public_path__ + "static/turtle-creek-house11-4b4db276b7cb92173af869e7f68f14e0.jpg";